export  const  PRODUCTS_LOAD = "PRODUCTS_LOAD";
export  const PRODUCTS_SUCCESS = "PRODUCTS_SUCCESS";
export const  PRODUCTS_ERROR = "PRODUCTS_ERROR";
export const  PRODUCTS_TYPE = "PRODUCTS_TYPE";
export const  PRODUCTS_PAGE = "PRODUCTS_PAGE";
export const  TOTAL_PRICE = "TOTAL_PRICE";
export const  CATEGORY = "CAT";
export const  BRAND = "BRAND";
export const  CARTITEMS = "CARTITEMS";

